import './claim-entity-detail.coverage-letter.scss';
import './common.scss';

import {
  ApolloCache,
  DefaultContext,
  FetchResult,
  MutationFunctionOptions,
} from '@apollo/client';
import {
  ContentTargetAreaType,
  CreateClaimClosingLetterMutation,
  Entity,
  Exact,
  useCreateClosingLetterMutation,
  useCreateCoverageLetterMutation,
} from '@converge/graphql';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { ConvergeButton, PaperLayout } from '@converge/ui/presentation';
import { FormProvider, useForm } from 'react-hook-form';

import { Box } from '@mui/material';
// import { CreateClaimField, getCreateClaimFieldProps } from '@converge/data';
import { ConvergeContents } from '../../contents';
import { DocumentsButton } from './claim-entity.detail.overview';
import { EnqueueSnackbar } from 'notistack';
import { InsuredEntityPageContainer } from '../insured/insured-entity.page.container';
import { convergeLogger } from '@converge/config';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { useConvergeSnackBar } from '@converge/ui/contexts';
import { useOutletContext } from 'react-router-dom';

interface IProps {
  claimEntity: Entity;
  claimUuid: string;
  coverageLetterContents: string;
}

export const ClaimEntityDetailCoverageLetter = () => {
  const { claimUuid, coverageLetterContents } = useOutletContext<IProps>();

  return (
    <ClaimEntityDetailCoverLetterInner
      content={coverageLetterContents}
      claimUuid={claimUuid}
    />
  );
};

export const closeClaimHandler = async (
  claimUuid: string,
  claimCreateClosingLetter: {
    (
      options?:
        | MutationFunctionOptions<
            CreateClaimClosingLetterMutation,
            Exact<{ claimUuid: string }>,
            DefaultContext,
            ApolloCache<unknown>
          >
        | undefined
    ): Promise<FetchResult<CreateClaimClosingLetterMutation>>;
    (arg0: { variables: { claimUuid: string } }): unknown;
  },
  notify: EnqueueSnackbar
) => {
  try {
    await claimCreateClosingLetter({
      variables: {
        claimUuid,
      },
    });
    notify({
      message: 'Close claim letter generated successfully',
      variant: 'success',
    });
  } catch (error) {
    notify(`Failed to generate close claim letter:`, {
      variant: 'error',
    });
  }
};

export const ClaimEntityDetailCoverLetterInner = ({
  content,
  claimUuid,
}: {
  content?: string;
  claimUuid: string;
}) => {
  const formMethods = useForm({
    // defaultValues,
  });

  const { notify } = useConvergeSnackBar();
  const { claimCreateClosingLetter, loading: claimCreateClosingLetterLoading } =
    useCreateClosingLetterMutation();
  const { claimCreateCoverageLetter, loading: createConvergeLetterLoading } =
    useCreateCoverageLetterMutation();

  const createCoverageLetterHandler = async (claimUuid: string) => {
    try {
      await claimCreateCoverageLetter({
        variables: {
          claimUuid,
        },
      });

      notify({
        message: 'Coverage letter generated successfully ',
        variant: 'success',
      });
    } catch (error) {
      convergeLogger.error(error);
      notify(`Failed to generate coverage letter`, {
        variant: 'error',
      });
    }
  };

  return (
    <InsuredEntityPageContainer
      title="Coverage letter"
      // onNext={() => navigateToQuotes()}
    >
      <PaperLayout className="claim-coverage-letter-layout">
        <FormProvider {...formMethods}>
          <div>
            <ConvergeContents
              title="Underwriting notes"
              content={content}
              targetArea={ContentTargetAreaType.Claim}
              targetUuid={claimUuid}
              label={'coverage_letter'}
              hideHeader
              containerWidth={12}
              labelMargin={30}
              minHeight={500}
              minHeightForTextFile={350}
              testId="underwriting-comments"
            />
          </div>
        </FormProvider>
        <Box className="claim-entity-footer">
          <Box className="document-button ">
            <ConvergeButton
              className="create-coverage-letter"
              onClick={() => {
                createCoverageLetterHandler(claimUuid);
              }}
              data-cy="coverage-letter-button"
              label={'Create coverage letter'}
              loading={createConvergeLetterLoading}
            />
            <DocumentsButton claimUuid={claimUuid} />

            <ConvergeButton
              onClick={() => {
                closeClaimHandler(claimUuid, claimCreateClosingLetter, notify);
              }}
              data-cy="create-claim-button"
              label={'Close Claim'}
              loading={claimCreateClosingLetterLoading}
            />
          </Box>
        </Box>
      </PaperLayout>
    </InsuredEntityPageContainer>
  );
};
